import { useQuery } from '@tanstack/react-query'

import API from '../../../utils/api'

export const useCasinoTransactions = (tokenId, enabled = false) => {
  const { data, isLoading, error } = useQuery(
    ['casino-transactions', tokenId],
    () => API.getPPTransactions(tokenId),
    {
      enabled: enabled && Boolean(tokenId),
      select: (response) => response.data.transactions ?? [],
      staleTime: 60_000,
    }
  )

  return {
    transactions: data ?? [],
    isLoading,
    error,
  }
}
